import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccessibilityQuickLinks, LazyBadge, LazyHeading, LazyLogo, LazyTag, LazyTextLink, LazyButton, LazyButtonBack, LazyButtonBase, LazyButtonIcon, LazyButtonNavigation, LazyCheckbox, LazyDate, LazyEmail, LazyFile, LazyHidden, LazyInput, LazyNumber, LazyPassword, LazyRadio, LazyRecaptchaInfo, LazyTextarea, LazyToggle, LazyWebformMarkup, LazySelect, LazySelectScheleton, LazyTelInput, LazyTelInputScheleton, LazyAlert, LazyArrowBendRightDownLarge, LazyArrowLeft, LazyArrowRegularLeftMobile, LazyArrowRegularRightMobile, LazyArrowRegularTop, LazyAudioBook, LazyBlog, LazyBook, LazyBooks, LazyCalendar, LazyCalendarAlt, LazyCart, LazyChat, LazyCheck, LazyCombo, LazyContact, LazyDelete, LazyDocument, LazyDownload, LazyDropdown, LazyDuplicate, LazyEbook, LazyEdit, LazyEllipse, LazyFacebook, LazyFloorplan, LazyFolder, LazyHide, LazyIcon, LazyImageIcon, LazyInfo, LazyInstagram, LazyLargeArrow, LazyLargeClose, LazyLinkAlt, LazyLinkArrow, LazyLinkedin, LazyMap, LazyMedia, LazyMediaPlay, LazyMiniArrowDown, LazyMiniArrowDropdown, LazyMiniArrowLink, LazyMiniArrowRegular, LazyMiniArrowSliderLeft, LazyMiniArrowSliderRight, LazyMiniArrowThin, LazyMiniArrowUp, LazyMiniBullet, LazyMiniCheck, LazyMiniCheckbox, LazyMiniCloseMedium, LazyMiniCloseSmall, LazyMiniDropdown, LazyMiniMinusSmall, LazyMiniPlusSmall, LazyMiniSmall, LazyMobileMenu, LazyNotification, LazyOffers, LazyPin, LazyPricelist, LazyProduct, LazyProfile, LazySearch, LazySet, LazySetting, LazyShow, LazyShowcases, LazySocialBlog, LazySocialFacebook, LazySocialInstagram, LazySocialLinkedin, LazySocialTwitter, LazySocialXing, LazySocialYoutube, LazySpotify, LazyTextlink, LazyTwitter, LazyUpload, LazyUserWork, LazyWarning, LazyWeb, LazyYoutube, LazyBreadcrumbs, LazyLinkList, LazyPagination, LazySearchField, LazyTextSpecial, LazyAddress, LazyCompany, LazyPersonalDetails, LazyPersonalInfo, LazyPhones, LazyProfessionalInfo, LazyTags, LazyHeaderCheckout, LazyLanguageSwitcher, LazyPageLoadingIndicator, LazyFooter, LazyFooterComplianceMenu, LazyFooterMenu, LazyFooterMetaMenu, LazyFooterSocial, LazyHeader, LazyHeaderActionButton, LazyHeaderActionCart, LazyHeaderActionMobileMenuToggle, LazyHeaderActionProfile, LazyHeaderActionSearch, LazyHeaderActions, LazyMainMenu, LazyMainMenuMobile, LazyMetaMenu, LazyNavigation, LazyNavigationMobile, LazySubMenu, LazySubMenuItems, LazySubMenuMobile, LazySubMenus, LazySubMenusMobile, LazyUseAutoHide, LazyUseMainMenu, LazyUseSubmenuVisibility, LazyModalNavigationMobile, LazyModalSearch, LazyUseSearch, LazyCbzFooter, LazyCbzHero, LazyCbzLinkItem, LazyCbzSearch, LazyPracticaBlock, LazyPracticaItem, LazySectionCbzAccordion, LazySectionCbzDownloads, LazySectionCbzLinks, LazySectionCbzNewContent, LazySectionCbzNewsletter, LazyAccordion, LazyAccordionItem, LazyComment, LazyCommentForm, LazyComments, LazyDownloadItem, LazyDownloads, LazyEmailContactForm, LazyEmployeeList, LazyEmployeeSingle, LazyEmployeeTeaser, LazyEventRegistrationForm, LazyEvents, LazyGoogleMap, LazyHero, LazyHeroColor, LazyHotspotItem, LazyHotspotItemModalContent, LazyImage, LazyIntrotext, LazyLinkListLarge, LazyLinkListLargeItem, LazyLinkListLargeItemEducationalOffering, LazyLinkListLargeItemEvent, LazyPersonBase, LazyPicture, LazyProductReview, LazyRoomIconItem, LazyRoomImageSlider, LazyRoomOverviewItem, LazySearchResult, LazySection, LazySectionFilters, LazySectionSocialWall, LazySectionSpecial, LazySectionTitle, LazyShare, LazyStickyEventTeaser, LazyStoriesSlide, LazyTableWithFade, LazyTab, LazyTabHeader, LazyTabs, LazyTeaserSingle, LazyTeaserSlide, LazyTeaserSlider, LazyTimelineFieldItem, LazyTimelineModalContent, LazyTimelineRegularCounter, LazyTimelineVideoCounter, LazyCard, LazyCardImage, LazyCardText, LazyToccoBase, LazyToccoBaseSidebar, LazyToccoAccordion, LazyToccoButtonTaxonomy, LazyToccoContactPersonTeaser, LazyToccoContactPersons, LazyToccoContactPersonsModal, LazyToccoEventTeaser, LazyToccoModuleAddToCart, LazyToccoModuleAddToCartDetails, LazyToccoRegistrationConferenceReview, LazyToccoRegistrationModuleReview, LazyToccoRegistrationSeminarReview, LazyToccoModuleModal, LazySectionToccoAccordion, LazySectionToccoContactPersons, LazySectionToccoDates, LazySectionToccoDownloads, LazySectionToccoEmployees, LazySectionToccoEntityTeaser, LazySectionToccoRelatedSeminars, LazySectionToccoSeminarModules, LazySectionToccoSeminarModulesCategory, LazySectionToccoShare, LazyModalContactForm, LazyModalEmployee, LazyModalEmpty, LazyModalVideo, LazyOpenJobContactPerson, LazySectionOpenJobContacts, LazySectionOpenJobQuote, LazySectionTwoColumnText, LazyEmployee, LazyNodeCbzLandingPage, LazyNodeEvent, LazyNodeLandingPage, LazyNodeNews, LazyNodeOpenJob, LazyNodePage, LazyNodeProtectedPage, LazyToccoCourse, LazyToccoELearning, LazyToccoIntroModule, LazyToccoModule, LazyToccoSeminar, LazyToccoWebinar, LazySectionAccordion, LazySectionAnchors, LazySectionCarousel, LazySectionComments, LazySectionContact, LazySectionContactPerson, LazySectionContainerWidgetMain, LazySectionDownloads, LazySectionEducationOverview, LazySectionEventListing, LazySectionEventRegistration, LazySectionEventRelated, LazySectionEventTeasers, LazySectionFeaturedNewsPosts, LazySectionForm, LazySectionFullHtmlText, LazySectionHero, LazySectionHeroHome, LazySectionHeroNews, LazySectionHeroSearch, LazySectionHotspotGraphic, LazySectionIframe, LazySectionImage, LazySectionInfoBox, LazySectionInfoBoxes, LazySectionInfoItems, LazySectionIntrotext, LazySectionJsScripts, LazySectionLargeLinklist, LazySectionLatestEducationOfferings, LazySectionLinklist, LazySectionListing, LazySectionMap, LazySectionMegaTeaser, LazySectionRoomOverview, LazySectionSchedule, LazySectionSeatingPlan, LazySectionShare, LazySectionShopStartpageInfo, LazySectionShopTeasers, LazySectionSidebar, LazySectionSingleTeaser, LazySectionSpecificTagsNews, LazySectionStickyEventTeaser, LazySectionStories, LazySectionTable, LazySectionTeaserGrid, LazySectionTeaserSlider, LazySectionTeaserTiles, LazySectionTestimonial, LazySectionText, LazySectionTextImage, LazySectionTimeline, LazySectionVideo, LazySections, LazyEmployeesListing, LazyEventsListing, LazyEventsListingConference, LazyEventsListingInfo, LazyNewsListing, LazyPracticasListing, LazyToccoListing, LazySidebarSection, LazyAuthorSidebar, LazyCareerAdviceToccoSidebar, LazyCtaSidebar, LazyLabelValueSidebar, LazyLocationSidebar, LazyLogoSidebar, LazyTagsSidebar, LazyTextLinkSidebar, LazyTextSidebar, LazySectionAuthorSidebar, LazySectionContainerWidgetSidebar, LazySectionCtaSidebar, LazySectionLabelValueSidebar, LazySectionLogoSidebar, LazySectionTextSidebar, LazyProducts, LazyShopAddToCartButton, LazyShopAddressModal, LazyShopCartItem, LazyShopCartModal, LazyShopCartTable, LazyShopCartTotals, LazyShopCategoryPage, LazyShopLoginForm, LazyShopLoginModal, LazyShopMarketingConsentCheckbox, LazyShopNotification, LazyShopNotifications, LazyShopProductFeatures, LazyShopProductLabels, LazyShopProductPage, LazyShopProductTeaser, LazyShopProductTeaserSmall, LazyShopPromotionCode, LazyShopSideCartItem, LazyShopAccountAddressCard, LazyShopAccountAddressForm, LazyShopAccountChangePassword, LazyShopAccountOrderDetails, LazyShopAccountPersonalDetails, LazyShopFilter, LazyShopFilterArticleType, LazyShopFilterLanguage, LazyShopProductListing, LazyShopSearch, LazyShopSubcategories, LazyUseProductCustomFields, LazyUseShopBreadcrumbs, LazyUseShopRegistrationError, LazyShopProductVariant } from '#components'
const lazyGlobalComponents = [
  ["AccessibilityQuickLinks", LazyAccessibilityQuickLinks],
["Badge", LazyBadge],
["Heading", LazyHeading],
["Logo", LazyLogo],
["Tag", LazyTag],
["TextLink", LazyTextLink],
["Button", LazyButton],
["ButtonBack", LazyButtonBack],
["ButtonBase", LazyButtonBase],
["ButtonIcon", LazyButtonIcon],
["ButtonNavigation", LazyButtonNavigation],
["Checkbox", LazyCheckbox],
["Date", LazyDate],
["Email", LazyEmail],
["File", LazyFile],
["Hidden", LazyHidden],
["Input", LazyInput],
["Number", LazyNumber],
["Password", LazyPassword],
["Radio", LazyRadio],
["RecaptchaInfo", LazyRecaptchaInfo],
["Textarea", LazyTextarea],
["Toggle", LazyToggle],
["WebformMarkup", LazyWebformMarkup],
["Select", LazySelect],
["SelectScheleton", LazySelectScheleton],
["TelInput", LazyTelInput],
["TelInputScheleton", LazyTelInputScheleton],
["Alert", LazyAlert],
["ArrowBendRightDownLarge", LazyArrowBendRightDownLarge],
["ArrowLeft", LazyArrowLeft],
["ArrowRegularLeftMobile", LazyArrowRegularLeftMobile],
["ArrowRegularRightMobile", LazyArrowRegularRightMobile],
["ArrowRegularTop", LazyArrowRegularTop],
["AudioBook", LazyAudioBook],
["Blog", LazyBlog],
["Book", LazyBook],
["Books", LazyBooks],
["Calendar", LazyCalendar],
["CalendarAlt", LazyCalendarAlt],
["Cart", LazyCart],
["Chat", LazyChat],
["Check", LazyCheck],
["Combo", LazyCombo],
["Contact", LazyContact],
["Delete", LazyDelete],
["Document", LazyDocument],
["Download", LazyDownload],
["Dropdown", LazyDropdown],
["Duplicate", LazyDuplicate],
["Ebook", LazyEbook],
["Edit", LazyEdit],
["Ellipse", LazyEllipse],
["Facebook", LazyFacebook],
["Floorplan", LazyFloorplan],
["Folder", LazyFolder],
["Hide", LazyHide],
["Icon", LazyIcon],
["ImageIcon", LazyImageIcon],
["Info", LazyInfo],
["Instagram", LazyInstagram],
["LargeArrow", LazyLargeArrow],
["LargeClose", LazyLargeClose],
["LinkAlt", LazyLinkAlt],
["LinkArrow", LazyLinkArrow],
["Linkedin", LazyLinkedin],
["Map", LazyMap],
["Media", LazyMedia],
["MediaPlay", LazyMediaPlay],
["MiniArrowDown", LazyMiniArrowDown],
["MiniArrowDropdown", LazyMiniArrowDropdown],
["MiniArrowLink", LazyMiniArrowLink],
["MiniArrowRegular", LazyMiniArrowRegular],
["MiniArrowSliderLeft", LazyMiniArrowSliderLeft],
["MiniArrowSliderRight", LazyMiniArrowSliderRight],
["MiniArrowThin", LazyMiniArrowThin],
["MiniArrowUp", LazyMiniArrowUp],
["MiniBullet", LazyMiniBullet],
["MiniCheck", LazyMiniCheck],
["MiniCheckbox", LazyMiniCheckbox],
["MiniCloseMedium", LazyMiniCloseMedium],
["MiniCloseSmall", LazyMiniCloseSmall],
["MiniDropdown", LazyMiniDropdown],
["MiniMinusSmall", LazyMiniMinusSmall],
["MiniPlusSmall", LazyMiniPlusSmall],
["MiniSmall", LazyMiniSmall],
["MobileMenu", LazyMobileMenu],
["Notification", LazyNotification],
["Offers", LazyOffers],
["Pin", LazyPin],
["Pricelist", LazyPricelist],
["Product", LazyProduct],
["Profile", LazyProfile],
["Search", LazySearch],
["Set", LazySet],
["Setting", LazySetting],
["Show", LazyShow],
["Showcases", LazyShowcases],
["SocialBlog", LazySocialBlog],
["SocialFacebook", LazySocialFacebook],
["SocialInstagram", LazySocialInstagram],
["SocialLinkedin", LazySocialLinkedin],
["SocialTwitter", LazySocialTwitter],
["SocialXing", LazySocialXing],
["SocialYoutube", LazySocialYoutube],
["Spotify", LazySpotify],
["Textlink", LazyTextlink],
["Twitter", LazyTwitter],
["Upload", LazyUpload],
["UserWork", LazyUserWork],
["Warning", LazyWarning],
["Web", LazyWeb],
["Youtube", LazyYoutube],
["Breadcrumbs", LazyBreadcrumbs],
["LinkList", LazyLinkList],
["Pagination", LazyPagination],
["SearchField", LazySearchField],
["TextSpecial", LazyTextSpecial],
["Address", LazyAddress],
["Company", LazyCompany],
["PersonalDetails", LazyPersonalDetails],
["PersonalInfo", LazyPersonalInfo],
["Phones", LazyPhones],
["ProfessionalInfo", LazyProfessionalInfo],
["Tags", LazyTags],
["HeaderCheckout", LazyHeaderCheckout],
["LanguageSwitcher", LazyLanguageSwitcher],
["PageLoadingIndicator", LazyPageLoadingIndicator],
["Footer", LazyFooter],
["FooterComplianceMenu", LazyFooterComplianceMenu],
["FooterMenu", LazyFooterMenu],
["FooterMetaMenu", LazyFooterMetaMenu],
["FooterSocial", LazyFooterSocial],
["Header", LazyHeader],
["HeaderActionButton", LazyHeaderActionButton],
["HeaderActionCart", LazyHeaderActionCart],
["HeaderActionMobileMenuToggle", LazyHeaderActionMobileMenuToggle],
["HeaderActionProfile", LazyHeaderActionProfile],
["HeaderActionSearch", LazyHeaderActionSearch],
["HeaderActions", LazyHeaderActions],
["MainMenu", LazyMainMenu],
["MainMenuMobile", LazyMainMenuMobile],
["MetaMenu", LazyMetaMenu],
["Navigation", LazyNavigation],
["NavigationMobile", LazyNavigationMobile],
["SubMenu", LazySubMenu],
["SubMenuItems", LazySubMenuItems],
["SubMenuMobile", LazySubMenuMobile],
["SubMenus", LazySubMenus],
["SubMenusMobile", LazySubMenusMobile],
["UseAutoHide", LazyUseAutoHide],
["UseMainMenu", LazyUseMainMenu],
["UseSubmenuVisibility", LazyUseSubmenuVisibility],
["ModalNavigationMobile", LazyModalNavigationMobile],
["ModalSearch", LazyModalSearch],
["UseSearch", LazyUseSearch],
["CbzFooter", LazyCbzFooter],
["CbzHero", LazyCbzHero],
["CbzLinkItem", LazyCbzLinkItem],
["CbzSearch", LazyCbzSearch],
["PracticaBlock", LazyPracticaBlock],
["PracticaItem", LazyPracticaItem],
["SectionCbzAccordion", LazySectionCbzAccordion],
["SectionCbzDownloads", LazySectionCbzDownloads],
["SectionCbzLinks", LazySectionCbzLinks],
["SectionCbzNewContent", LazySectionCbzNewContent],
["SectionCbzNewsletter", LazySectionCbzNewsletter],
["Accordion", LazyAccordion],
["AccordionItem", LazyAccordionItem],
["Comment", LazyComment],
["CommentForm", LazyCommentForm],
["Comments", LazyComments],
["DownloadItem", LazyDownloadItem],
["Downloads", LazyDownloads],
["EmailContactForm", LazyEmailContactForm],
["EmployeeList", LazyEmployeeList],
["EmployeeSingle", LazyEmployeeSingle],
["EmployeeTeaser", LazyEmployeeTeaser],
["EventRegistrationForm", LazyEventRegistrationForm],
["Events", LazyEvents],
["GoogleMap", LazyGoogleMap],
["Hero", LazyHero],
["HeroColor", LazyHeroColor],
["HotspotItem", LazyHotspotItem],
["HotspotItemModalContent", LazyHotspotItemModalContent],
["Image", LazyImage],
["Introtext", LazyIntrotext],
["LinkListLarge", LazyLinkListLarge],
["LinkListLargeItem", LazyLinkListLargeItem],
["LinkListLargeItemEducationalOffering", LazyLinkListLargeItemEducationalOffering],
["LinkListLargeItemEvent", LazyLinkListLargeItemEvent],
["PersonBase", LazyPersonBase],
["Picture", LazyPicture],
["ProductReview", LazyProductReview],
["RoomIconItem", LazyRoomIconItem],
["RoomImageSlider", LazyRoomImageSlider],
["RoomOverviewItem", LazyRoomOverviewItem],
["SearchResult", LazySearchResult],
["Section", LazySection],
["SectionFilters", LazySectionFilters],
["SectionSocialWall", LazySectionSocialWall],
["SectionSpecial", LazySectionSpecial],
["SectionTitle", LazySectionTitle],
["Share", LazyShare],
["StickyEventTeaser", LazyStickyEventTeaser],
["StoriesSlide", LazyStoriesSlide],
["TableWithFade", LazyTableWithFade],
["Tab", LazyTab],
["TabHeader", LazyTabHeader],
["Tabs", LazyTabs],
["TeaserSingle", LazyTeaserSingle],
["TeaserSlide", LazyTeaserSlide],
["TeaserSlider", LazyTeaserSlider],
["TimelineFieldItem", LazyTimelineFieldItem],
["TimelineModalContent", LazyTimelineModalContent],
["TimelineRegularCounter", LazyTimelineRegularCounter],
["TimelineVideoCounter", LazyTimelineVideoCounter],
["Card", LazyCard],
["CardImage", LazyCardImage],
["CardText", LazyCardText],
["ToccoBase", LazyToccoBase],
["ToccoBaseSidebar", LazyToccoBaseSidebar],
["ToccoAccordion", LazyToccoAccordion],
["ToccoButtonTaxonomy", LazyToccoButtonTaxonomy],
["ToccoContactPersonTeaser", LazyToccoContactPersonTeaser],
["ToccoContactPersons", LazyToccoContactPersons],
["ToccoContactPersonsModal", LazyToccoContactPersonsModal],
["ToccoEventTeaser", LazyToccoEventTeaser],
["ToccoModuleAddToCart", LazyToccoModuleAddToCart],
["ToccoModuleAddToCartDetails", LazyToccoModuleAddToCartDetails],
["ToccoRegistrationConferenceReview", LazyToccoRegistrationConferenceReview],
["ToccoRegistrationModuleReview", LazyToccoRegistrationModuleReview],
["ToccoRegistrationSeminarReview", LazyToccoRegistrationSeminarReview],
["ToccoModuleModal", LazyToccoModuleModal],
["SectionToccoAccordion", LazySectionToccoAccordion],
["SectionToccoContactPersons", LazySectionToccoContactPersons],
["SectionToccoDates", LazySectionToccoDates],
["SectionToccoDownloads", LazySectionToccoDownloads],
["SectionToccoEmployees", LazySectionToccoEmployees],
["SectionToccoEntityTeaser", LazySectionToccoEntityTeaser],
["SectionToccoRelatedSeminars", LazySectionToccoRelatedSeminars],
["SectionToccoSeminarModules", LazySectionToccoSeminarModules],
["SectionToccoSeminarModulesCategory", LazySectionToccoSeminarModulesCategory],
["SectionToccoShare", LazySectionToccoShare],
["ModalContactForm", LazyModalContactForm],
["ModalEmployee", LazyModalEmployee],
["ModalEmpty", LazyModalEmpty],
["ModalVideo", LazyModalVideo],
["OpenJobContactPerson", LazyOpenJobContactPerson],
["SectionOpenJobContacts", LazySectionOpenJobContacts],
["SectionOpenJobQuote", LazySectionOpenJobQuote],
["SectionTwoColumnText", LazySectionTwoColumnText],
["Employee", LazyEmployee],
["NodeCbzLandingPage", LazyNodeCbzLandingPage],
["NodeEvent", LazyNodeEvent],
["NodeLandingPage", LazyNodeLandingPage],
["NodeNews", LazyNodeNews],
["NodeOpenJob", LazyNodeOpenJob],
["NodePage", LazyNodePage],
["NodeProtectedPage", LazyNodeProtectedPage],
["ToccoCourse", LazyToccoCourse],
["ToccoELearning", LazyToccoELearning],
["ToccoIntroModule", LazyToccoIntroModule],
["ToccoModule", LazyToccoModule],
["ToccoSeminar", LazyToccoSeminar],
["ToccoWebinar", LazyToccoWebinar],
["SectionAccordion", LazySectionAccordion],
["SectionAnchors", LazySectionAnchors],
["SectionCarousel", LazySectionCarousel],
["SectionComments", LazySectionComments],
["SectionContact", LazySectionContact],
["SectionContactPerson", LazySectionContactPerson],
["SectionContainerWidgetMain", LazySectionContainerWidgetMain],
["SectionDownloads", LazySectionDownloads],
["SectionEducationOverview", LazySectionEducationOverview],
["SectionEventListing", LazySectionEventListing],
["SectionEventRegistration", LazySectionEventRegistration],
["SectionEventRelated", LazySectionEventRelated],
["SectionEventTeasers", LazySectionEventTeasers],
["SectionFeaturedNewsPosts", LazySectionFeaturedNewsPosts],
["SectionForm", LazySectionForm],
["SectionFullHtmlText", LazySectionFullHtmlText],
["SectionHero", LazySectionHero],
["SectionHeroHome", LazySectionHeroHome],
["SectionHeroNews", LazySectionHeroNews],
["SectionHeroSearch", LazySectionHeroSearch],
["SectionHotspotGraphic", LazySectionHotspotGraphic],
["SectionIframe", LazySectionIframe],
["SectionImage", LazySectionImage],
["SectionInfoBox", LazySectionInfoBox],
["SectionInfoBoxes", LazySectionInfoBoxes],
["SectionInfoItems", LazySectionInfoItems],
["SectionIntrotext", LazySectionIntrotext],
["SectionJsScripts", LazySectionJsScripts],
["SectionLargeLinklist", LazySectionLargeLinklist],
["SectionLatestEducationOfferings", LazySectionLatestEducationOfferings],
["SectionLinklist", LazySectionLinklist],
["SectionListing", LazySectionListing],
["SectionMap", LazySectionMap],
["SectionMegaTeaser", LazySectionMegaTeaser],
["SectionRoomOverview", LazySectionRoomOverview],
["SectionSchedule", LazySectionSchedule],
["SectionSeatingPlan", LazySectionSeatingPlan],
["SectionShare", LazySectionShare],
["SectionShopStartpageInfo", LazySectionShopStartpageInfo],
["SectionShopTeasers", LazySectionShopTeasers],
["SectionSidebar", LazySectionSidebar],
["SectionSingleTeaser", LazySectionSingleTeaser],
["SectionSpecificTagsNews", LazySectionSpecificTagsNews],
["SectionStickyEventTeaser", LazySectionStickyEventTeaser],
["SectionStories", LazySectionStories],
["SectionTable", LazySectionTable],
["SectionTeaserGrid", LazySectionTeaserGrid],
["SectionTeaserSlider", LazySectionTeaserSlider],
["SectionTeaserTiles", LazySectionTeaserTiles],
["SectionTestimonial", LazySectionTestimonial],
["SectionText", LazySectionText],
["SectionTextImage", LazySectionTextImage],
["SectionTimeline", LazySectionTimeline],
["SectionVideo", LazySectionVideo],
["Sections", LazySections],
["EmployeesListing", LazyEmployeesListing],
["EventsListing", LazyEventsListing],
["EventsListingConference", LazyEventsListingConference],
["EventsListingInfo", LazyEventsListingInfo],
["NewsListing", LazyNewsListing],
["PracticasListing", LazyPracticasListing],
["ToccoListing", LazyToccoListing],
["SidebarSection", LazySidebarSection],
["AuthorSidebar", LazyAuthorSidebar],
["CareerAdviceToccoSidebar", LazyCareerAdviceToccoSidebar],
["CtaSidebar", LazyCtaSidebar],
["LabelValueSidebar", LazyLabelValueSidebar],
["LocationSidebar", LazyLocationSidebar],
["LogoSidebar", LazyLogoSidebar],
["TagsSidebar", LazyTagsSidebar],
["TextLinkSidebar", LazyTextLinkSidebar],
["TextSidebar", LazyTextSidebar],
["SectionAuthorSidebar", LazySectionAuthorSidebar],
["SectionContainerWidgetSidebar", LazySectionContainerWidgetSidebar],
["SectionCtaSidebar", LazySectionCtaSidebar],
["SectionLabelValueSidebar", LazySectionLabelValueSidebar],
["SectionLogoSidebar", LazySectionLogoSidebar],
["SectionTextSidebar", LazySectionTextSidebar],
["Products", LazyProducts],
["ShopAddToCartButton", LazyShopAddToCartButton],
["ShopAddressModal", LazyShopAddressModal],
["ShopCartItem", LazyShopCartItem],
["ShopCartModal", LazyShopCartModal],
["ShopCartTable", LazyShopCartTable],
["ShopCartTotals", LazyShopCartTotals],
["ShopCategoryPage", LazyShopCategoryPage],
["ShopLoginForm", LazyShopLoginForm],
["ShopLoginModal", LazyShopLoginModal],
["ShopMarketingConsentCheckbox", LazyShopMarketingConsentCheckbox],
["ShopNotification", LazyShopNotification],
["ShopNotifications", LazyShopNotifications],
["ShopProductFeatures", LazyShopProductFeatures],
["ShopProductLabels", LazyShopProductLabels],
["ShopProductPage", LazyShopProductPage],
["ShopProductTeaser", LazyShopProductTeaser],
["ShopProductTeaserSmall", LazyShopProductTeaserSmall],
["ShopPromotionCode", LazyShopPromotionCode],
["ShopSideCartItem", LazyShopSideCartItem],
["ShopAccountAddressCard", LazyShopAccountAddressCard],
["ShopAccountAddressForm", LazyShopAccountAddressForm],
["ShopAccountChangePassword", LazyShopAccountChangePassword],
["ShopAccountOrderDetails", LazyShopAccountOrderDetails],
["ShopAccountPersonalDetails", LazyShopAccountPersonalDetails],
["ShopFilter", LazyShopFilter],
["ShopFilterArticleType", LazyShopFilterArticleType],
["ShopFilterLanguage", LazyShopFilterLanguage],
["ShopProductListing", LazyShopProductListing],
["ShopSearch", LazyShopSearch],
["ShopSubcategories", LazyShopSubcategories],
["UseProductCustomFields", LazyUseProductCustomFields],
["UseShopBreadcrumbs", LazyUseShopBreadcrumbs],
["UseShopRegistrationError", LazyUseShopRegistrationError],
["ShopProductVariant", LazyShopProductVariant],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
